import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Hard-force light theme (Attio-like) by removing any lingering `dark` class.
// This prevents cached/persisted theme state from flipping the app back to dark.
document.documentElement.classList.remove("dark");

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
